import { render, staticRenderFns } from "./QARight.vue?vue&type=template&id=835b643a&scoped=true"
import script from "./QARight.vue?vue&type=script&lang=js"
export * from "./QARight.vue?vue&type=script&lang=js"
import style0 from "./QARight.vue?vue&type=style&index=0&id=835b643a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835b643a",
  null
  
)

export default component.exports